export default {
    "chip": [
        "Обратите винмание - изменение данных параметров может сильно сказаться на управляемости транспортного средства как в лучшую так и в худшую сторону, вплоть до полной неуправляемости. Тщательно проверяйте параметры перед их покупкой, каждое изменение. Вы делаете на свой страх и риск. Установка значений, которые могут нечестным способом увеличивать технические характеристики транспорта, повлечет за собой наказание, вплоть до блокировки учетной записи"
    ],
    "wheels": [
        "Параметры \"Диаметр колес\" и \"Ширина колес\" доступны только для не стоковых дисков. Изменить размер стоковых дисков нельзя"
    ]
}